import React from "react";
import classes from "./SkillTemp.module.css";

const SkillsTemp = ({ name, icon }) => {
  return (
    <div className={classes.Skill}>
      <div className={classes.SkillIcon}>{icon}</div>
      <div className={classes.SkillName}>{name}</div>
    </div>
  );
};

export default SkillsTemp;
